import { Components, Theme } from '@mui/material';
import { headerSizes } from '../../../submodules/web-shared/elements/RedesignedHeader/const';

export const DRAWER_SIZES = {
  PRIMARY: 480,
  SECONDARY: 360,
};

export default {
  defaultProps: {
    ModalProps: {
      slotProps: {
        backdrop: { invisible: true }
      }
    }
  },
  styleOverrides: {
    root: {
      //width: 0 is needed to allow interaction with elements outside drawer when drawer variant is 'temporary'
      width: 0,
    },
    docked: {
      width: DRAWER_SIZES.PRIMARY,
    },
    paper: ({ theme }) => ({
      width: DRAWER_SIZES.PRIMARY,
      top: `${headerSizes.HEADER}px`,
      height: `calc(100% - ${headerSizes.HEADER}px)`,
      [theme.breakpoints.down('md')]: {
        width: '100%',
        height: '100%',
        top: 0
      },
    })
  }
} as Components<Theme>['MuiDrawer'];